// extracted by mini-css-extract-plugin
export default {"sendIcon":"collection-modal_sendIcon__bhhxw","content":"collection-modal_content__yVUvm","badgeContainer":"collection-modal_badgeContainer__LMAgT"};